module.exports = __webpack_public_path__ + "img/slide-33.894b42b8.jpeg";